export const workspace = {
  routes: [
    {
      path: "/workspace/library/access-restriction",
      component: () => import("../workspace-library-access-restriction-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/access-restriction",
      component: () => import("../management-library-access-restriction-view"),
    },
  ],
};
